'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_display_Img_Img = require('../Img/Img.cjs.js');
const components_display_SkeletonLoader_SkeletonBlock_SkeletonBlock = require('../SkeletonLoader/SkeletonBlock/SkeletonBlock.cjs.js');

const Styles = styleEncapsulation.labelStyles("LoadableImg", {
  placeholder: react.css`
    position: absolute;
    left: -9999;
  `
});
const ImgSkeletonLoader = (props) => {
  const [ratioWidth, ratioHeight] = (props.aspectRatio || "").split(":").map((part) => {
    return part && parseFloat(part);
  });
  const aspectRatio = ratioWidth && ratioHeight ? ratioWidth / ratioHeight : void 0;
  return react.jsx(components_display_SkeletonLoader_SkeletonBlock_SkeletonBlock.SkeletonBlock, { aspectRatio, height: props.height, width: props.width === null ? void 0 : props.width });
};
const LoadableImg = (props) => {
  const [loaded, setLoaded] = React.useState(false);
  const onLoad = (event) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(event);
    }
    setLoaded(true);
  };
  return react.jsx(
    "div",
    { "data-zds": true },
    react.jsx(
      "div",
      { css: loaded ? void 0 : Styles.placeholder, "data-zds": true },
      react.jsx(components_display_Img_Img.Img, Object.assign({}, props, { onLoad }))
    ),
    !loaded && react.jsx(ImgSkeletonLoader, Object.assign({}, props))
  );
};

exports.LoadableImg = LoadableImg;
//# sourceMappingURL=LoadableImg.cjs.js.map
